import {
    Box,
    Button,
    Center,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    HStack,
    Img,
    SimpleGrid,
    Text,
    useDimensions,
    useDisclosure
} from '@chakra-ui/react';
import React, {useEffect, useRef, useState} from 'react';
import {atom, useRecoilState} from 'recoil';
import {LinkedinSvg, TwitterSvg} from '../../../assets';
import {useLocation, useNavigate, useParams, useSearchParams} from 'react-router-dom';
import axios from "axios";
import {SEO} from "../../../components/SEO";
import FullCrossPlus from "../../../components/FullCrossPlus";
import {htmlDecode} from "../../../utils/htmlDecode";

const selectedCompany = atom({
    key: 'selected-company__companies',
    default: null,
});

let portfolioDetailPageData = {};

const PortfolioDetail = ({companies, fromBio}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [searchParams, setSearchParams] = useSearchParams();
    const [companyDetail, setCompanyDetail] = useRecoilState(selectedCompany);
    const navigate = useNavigate();
    const location = useLocation();
    const [pageData, setPageData] = useState(undefined)
    const pageRef = useRef();
    const params = useParams();
    const company = fromBio ? companies?.find((c) => c?.slug === params?.portfolioSlug) : typeof companyDetail === 'number' ? companies[companyDetail] : null;
    const activeSector = searchParams.get('sector');
    const showAll = searchParams.get('show');
    const statusFlag = searchParams.get('status');
    const series = searchParams.get('series');
    const hasFilter = showAll || activeSector;
    
    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) + 1 || 0;

    useEffect(() => {
        // console.log('companyDetail 1', window.performance.memory.usedJSHeapSize);
        
        const abortController = new AbortController();
        const fetchCompanyData = async () => {
            if(!portfolioDetailPageData.hasOwnProperty(company?.slug || params?.portfolioSlug)) {
                portfolioDetailPageData[company?.slug || params?.portfolioSlug] = await axios.get(`/wp-json/wp/v2/investment?acf_format=standard&slug=${company?.slug || params?.portfolioSlug}`, {signal: abortController.signal}).then(resp => {
                    return resp.data[0];
                });
            }
            setPageData(portfolioDetailPageData[company?.slug || params?.portfolioSlug])
        }
        let time = false;
        if (company?.slug || params?.portfolioSlug) {
            time = setTimeout(function() {
                fetchCompanyData();
            }, 250);
            
        }
        return () => {
            abortController.abort();
            if(time) {
                clearTimeout(time);
            }
        }
    }, [company, params.portfolioSlug])

    return (
        <Box ref={pageRef}>
            {Array(count)
                .fill('')
                .map((_, key) => (
                    <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                ))}
            {pageData?.yoast_head_json?.og_title &&
                <SEO
                    image={pageData?.yoast_head_json?.og_image && pageData?.yoast_head_json?.og_image[0]?.url}
                    title={pageData?.title?.rendered}
                    ogTitle={pageData?.yoast_head_json?.og_title}
                    description={pageData?.yoast_head_json?.og_description}
                    url={pageData?.yoast_head_json?.og_url}
                    type={pageData?.yoast_head_json?.og_type}
                    siteName={pageData?.yoast_head_json?.og_site_name}
                    robots={`${pageData?.yoast_head_json?.robots.index}, ${pageData?.yoast_head_json?.robots.follow}`}
                />
            }
            <Drawer
                isOpen={fromBio ? !!params?.portfolioSlug : typeof companyDetail === 'number'}
                placement="right"
                onClose={() => {
                    let url = fromBio ? `/teammember/${params?.slug}` : `/companies`
                    if (activeSector) {
                        url += `?sector=${activeSector}`
                    }
                    if (showAll) {
                        url += `?show=all`
                    }
                    if(statusFlag) {
                        url += `${(hasFilter?'&':'?')}status=${statusFlag}`;
                    }
                    if(series) {
                        url += `${(hasFilter?'&':'?')}series=${series}`;
                    }
                    if (fromBio) {
                        setCompanyDetail(null)
                    }
                    /*
                    history.pushState(null, null, url);
                    onClose();
                    */
                    navigate(url, {
                        state: {
                            from: location.pathname,
                            comingFrom: location.pathname
                        }
                    })
                }}
                preserveScrollBarGap
            >
                <DrawerOverlay/>
                <DrawerContent maxW={['calc(100% - 30px)', '542px']} top={'19.2vh !important'} overflow='visible'>
                    <DrawerCloseButton
                        bgColor={'brand.700'}
                        borderRadius={'full'}
                        color={'white'}
                        size={'lg'}
                        _focus={{
                            boxShadow: 'none',
                        }}
                        _active={{
                            backgroundColor: 'brand.700 !important',
                        }}
                        _hover={{
                            backgroundColor: 'brand.700 !important',
                        }}
                        sx={{
                            left: '-20px',
                            top: '-20px',
                        }}
                    />
                    <DrawerHeader minH={'180px'} as={Center}>
                        <Img
                            userSelect={'none'}
                            maxHeight={'140px'}
                            alt={'profile-avatar'}
                            src={company?.company_logo}
                        />
                    </DrawerHeader>

                    <DrawerBody
                        bgColor={'#F9F9F9'}
                        pb={['3.5', '0 !important']}
                        p={['40px', '60px']}
                        display={'flex'}
                        flexDirection={'column'}
                    >
                        <Text
                            fontSize={['1.125rem', '2rem']}
                            mb={'60px'}
                            lineHeight={{base: '25px', sm: '38.4px'}}
                            letterSpacing={'-1px'}
                            // minH={'152px'}
                            // noOfLines={6}
                        >
                            {company?.long_description}
                        </Text>
                        <Box mb={'40px'}>
                            <SimpleGrid columns={2} spacing={[6, 8]}>
                                {company?.sector && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            Sector
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.investment_sectors?.length > 0
                                                ? company?.investment_sectors.map((i) => htmlDecode(i.name)).join(', ')
                                                : ''}
                                        </Text>
                                    </Box>
                                )}
                                {company?.investment_status?.[0].name && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            company status
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.company_status}
                                        </Text>
                                    </Box>
                                )}
                                {company?.first_funded_round && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            First Investment
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {(company?.first_funded_round == 'Series B' ? 'Series B+' : company?.first_funded_round)}
                                        </Text>
                                    </Box>
                                )}
                                {company?.first_funded_year && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            year funded
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.first_funded_year}
                                        </Text>
                                    </Box>
                                )}
                                {company?.venrock_partners?.[0]?.name && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            venrock team
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                            dangerouslySetInnerHTML={{
                                                __html: company?.venrock_partners.map((i) => htmlDecode(i.name)).join('<br />'),
                                            }}
                                        />
                                    </Box>
                                )}
                            </SimpleGrid>
                        </Box>
                        <HStack mt={'auto'} mb={'1rem'}>
                            {company?.website_url && (
                                <Button
                                    mr={'10px'}
                                    size={'lg'}
                                    isActive
                                    onClick={() => window.open(company?.website_url, '_blank')}
                                >
                                    {company?.website_url
                                        .split('/')
                                        .slice(2, 3)
                                        .join('')
                                        .replace('www.', '')}
                                </Button>
                            )}
                            <HStack spacing={2}>
                                {company?.twitter_url && (
                                    <Button
                                        size={'xs'}
                                        variant={'solid'}
                                        bgColor={'transparent'}
                                        iconSpacing={0}
                                        borderRadius={'full'}
                                        onClick={() => window.open(company?.twitter_url, '_blank')}
                                    >
                                        <TwitterSvg/>
                                    </Button>
                                )}
                                {company?.linkedin_url && (
                                    <Button
                                        size={'xs'}
                                        variant={'solid'}
                                        bgColor={'transparent'}
                                        iconSpacing={0}
                                        borderRadius={'full'}
                                        onClick={() => window.open(company?.linkedin_url, '_blank')}
                                    >
                                        <LinkedinSvg/>
                                    </Button>
                                )}
                            </HStack>
                        </HStack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Box>
    );
};
export default PortfolioDetail;
export {selectedCompany};
